export const planeat_user_group_hierarchy = [
    {'name':'system_admin_users','hierarchy':6},
    {'name':'company_manager_users','hierarchy':5},
    {'name':'office_manager_users','hierarchy':4},
    {'name':'kitchen_manager_users','hierarchy':3},
    {'name':'eater_group_admin_users','hierarchy':2},
    {'name':'eater_users','hierarchy':1}
]